import { EXCLUDED_QUALITY_IDS } from 'constants/possessions';
import { createSelector } from 'reselect';
import { normalize } from 'utils/stringFunctions';

const getCategories = (state, { categories }) => categories;
const getFilterString = (state, { filterString }) => filterString;
const getQualities = ({ myself: { qualities } }) => qualities;

const isExcluded = id => EXCLUDED_QUALITY_IDS.indexOf(id) >= 0;

const inputs = [getCategories, getFilterString, getQualities];

const output = (categories, filterString, qualities) => categories
  .map((c, i) => ({ ...c, id: i }))
  .filter(hasMatchingQualities({ filterString, qualities }));

export default createSelector(inputs, output);

export function hasMatchingQualities({ filterString, qualities }) {
  return (category) => {
    const matchingQualities = category.qualities
      .filter(id => !isExcluded(id))
      .map(id => qualities.find(_ => _.id === id));
    return matchingQualities.some(matchesFilterString({ filterString }));
  };
}

export function matchesFilterString({ filterString }) {
  return q => normalize(q.name).indexOf(normalize(filterString)) >= 0;
}